/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu, Jul 22nd 2021, 8:51:56 am
 *
 * *****************************************************
 */

import styled from 'styled-components';

import texts from 'constants/texts';

export const Container = styled.div`
  width: 100%;
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.6rem 3.6rem 1.6rem 1.9rem;
    span {
      ${texts.body['Body 1 - 14px - SB']}
      text-align: left;
    }
    svg {
      margin-left: auto;
      transform: translateX(0);
      transition: transform 0.2s linear;
    }
  }
  button > *:first-child {
    flex-shrink: 0;
  }
  button > *:last-child {
    flex-shrink: 0;
  }

  &:hover {
    svg {
      transform: translateX(1rem);
    }
  }
`;

export const WorkspaceAvatar = styled.div<{ color: string }>`
  width: 4.4rem;
  height: 4.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 600;
  font-size: 2rem;
  border-radius: var(--p-border-radius-base);
  margin-right: 1.5rem;
  background-color: ${({ color }) => color};
`;
